import i18n from '@/locales/i18n';

function readErrMessage(err) {
  return String(err?.message ?? err?.msg ?? '').trim();
}

/**
 * Map trial claim API errors to user-facing copy (never raw「系统内部错误 (500)」).
 * @param {unknown} err
 * @returns {string}
 */
export function resolveTrialClaimUserMessage(err) {
  const t = i18n.global.t;
  const raw = readErrMessage(err);
  const code = Number(err?.code);

  if (/already\s*claim|已经领取/i.test(raw)) {
    return '';
  }
  if (
    code === 503 ||
    /grant\s*pending|正在发放|mint_pending|try\s*again/i.test(raw)
  ) {
    return t('trialFund.claimPending');
  }
  if (/timeout|504|gateway\s*timeout/i.test(raw)) {
    return t('trialFund.claimPending');
  }
  if (/internal|系统内部|\(500\)/i.test(raw)) {
    return t('trialFund.claimRetryLater');
  }
  if (raw) {
    return raw;
  }
  return t('trialFund.claimRetryLater');
}
